var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i5 = decorators.length - 1, decorator; i5 >= 0; i5--)
    if (decorator = decorators[i5])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// css-inline:components/ds-review-card/ds-review-card.css
var ds_review_card_default = ":host {\n  display: flex;\n  flex-direction: column;\n  background: var(--color-white-50);\n  box-shadow: var(--surface-shadow-2);\n  overflow: hidden;\n  padding: var(--spacing-300);\n  border-radius: var(--border-radius-s);\n}\n\n.media {\n  position: relative;\n  overflow: hidden;\n  margin-bottom: var(--spacing-400);\n  border-radius: var(--border-radius-s) var(--border-radius-s);\n\n  & img {\n    width: 100%;\n    /* aspect-ratio: 1; */\n    object-fit: cover;\n    display: block;\n  }\n}\n\n/* Video frame: aspect-ratio is set inline from the video's own dimensions. */\n.media-frame {\n  background: var(--color-black-900);\n\n  & video,\n  & iframe,\n  & img {\n    width: 100%;\n    height: 100%;\n    border: none;\n    display: block;\n  }\n\n  & video,\n  & img {\n    object-fit: contain;\n  }\n}\n\n.media-video {\n  cursor: pointer;\n\n  @media (hover: hover) {\n    /* :not(.hidden) so this doesn't fight the exit transform on the way out. */\n    &:hover .play-btn:not(.hidden) {\n      transform: translate(-50%, -50%) scale(1.1);\n    }\n  }\n}\n\n/*\n * Where hover drives playback there is nothing to click, so neither the frame\n * nor the play button should offer a pointer cursor and imply otherwise.\n */\n.media-video.inert {\n  cursor: default;\n\n  & .play-btn {\n    cursor: default;\n  }\n}\n\n.play-btn {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: none;\n  background: var(--color-yellow-200);\n  color: var(--color-black-900);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0 0 3px;\n}\n\n/*\n * Top right rather than centred, so it never covers a talking head \u2014 and not\n * bottom, where burnt-in captions and platform watermarks usually sit.\n */\n.sound-btn {\n  position: absolute;\n  top: var(--spacing-200);\n  right: var(--spacing-200);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: none;\n  background: var(--color-yellow-200);\n  color: var(--color-black-900);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n\n  &:hover:not(.hidden) {\n    transform: scale(1.1);\n  }\n}\n\n/*\n * The two buttons hand over to each other rather than one simply replacing the\n * other. Both stay in the DOM so the exchange can be animated at all, and\n * `visibility` carries the hidden one out of the tab order and the accessibility\n * tree \u2014 it transitions discretely, flipping only at the far end of the timing,\n * so it hides after the fade rather than cutting it short.\n *\n * The delay is deliberately asymmetric: whoever is leaving goes immediately, and\n * whoever is arriving follows a beat later. That gap is the choreography \u2014 a\n * straight cross-fade reads as a glitch rather than a handover.\n */\n.play-btn,\n.sound-btn {\n  transition:\n    opacity 180ms ease,\n    transform 180ms ease,\n    visibility 180ms;\n  transition-delay: 110ms;\n}\n\n/*\n * The toggle hangs back further than a plain handover would need: the preview\n * should be visibly running before a control for its sound turns up, so it reads\n * as following the video rather than racing the play button off screen.\n *\n * It also takes longer to arrive than the play button does, and eases out of its\n * own deceleration curve, so it settles into place instead of snapping. Its exit\n * stays brisk \u2014 see the .hidden rule below.\n */\n.sound-btn {\n  transition:\n    opacity 300ms ease,\n    transform 300ms cubic-bezier(0.2, 0.7, 0.3, 1),\n    visibility 300ms;\n  transition-delay: 320ms;\n}\n\n/* Whoever is leaving goes at once \u2014 the delays above are for arrivals only.\n   Higher specificity than the .sound-btn rule, so its exit stays immediate. */\n.play-btn.hidden,\n.sound-btn.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transition-delay: 0ms;\n}\n\n/* Shrinking away from the centre, so it reads as receding rather than sliding. */\n.play-btn.hidden {\n  transform: translate(-50%, -50%) scale(0.85);\n}\n\n/*\n * Rises the last few pixels into place rather than just fading up, which gives\n * the arrival a direction. Kept small \u2014 at 36px across, more than a nudge starts\n * to look like the button fell out of the corner.\n *\n * The shorter duration is what keeps leaving brisk despite the slower entrance\n * above; higher specificity, so it wins for the exit only.\n */\n.sound-btn.hidden {\n  transform: translateY(6px) scale(0.9);\n  transition-duration: 160ms;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .play-btn,\n  .sound-btn {\n    transition: none;\n    transition-delay: 0ms;\n  }\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-200);\n  flex: 1;\n}\n\n.body-quote {\n  padding: var(--spacing-500) var(--spacing-600);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-300);\n  flex: 1;\n  justify-content: center;\n}\n\n.author {\n  font-weight: 600;\n}\n";

// node_modules/@lit/reactive-element/css-tag.js
var t = globalThis;
var e = t.ShadowRoot && (void 0 === t.ShadyCSS || t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype;
var s = /* @__PURE__ */ Symbol();
var o = /* @__PURE__ */ new WeakMap();
var n = class {
  constructor(t4, e5, o6) {
    if (this._$cssResult$ = true, o6 !== s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t4, this.t = e5;
  }
  get styleSheet() {
    let t4 = this.o;
    const s4 = this.t;
    if (e && void 0 === t4) {
      const e5 = void 0 !== s4 && 1 === s4.length;
      e5 && (t4 = o.get(s4)), void 0 === t4 && ((this.o = t4 = new CSSStyleSheet()).replaceSync(this.cssText), e5 && o.set(s4, t4));
    }
    return t4;
  }
  toString() {
    return this.cssText;
  }
};
var r = (t4) => new n("string" == typeof t4 ? t4 : t4 + "", void 0, s);
var i = (t4, ...e5) => {
  const o6 = 1 === t4.length ? t4[0] : e5.reduce((e6, s4, o7) => e6 + ((t5) => {
    if (true === t5._$cssResult$) return t5.cssText;
    if ("number" == typeof t5) return t5;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + t5 + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(s4) + t4[o7 + 1], t4[0]);
  return new n(o6, t4, s);
};
var S = (s4, o6) => {
  if (e) s4.adoptedStyleSheets = o6.map((t4) => t4 instanceof CSSStyleSheet ? t4 : t4.styleSheet);
  else for (const e5 of o6) {
    const o7 = document.createElement("style"), n5 = t.litNonce;
    void 0 !== n5 && o7.setAttribute("nonce", n5), o7.textContent = e5.cssText, s4.appendChild(o7);
  }
};
var c = e ? (t4) => t4 : (t4) => t4 instanceof CSSStyleSheet ? ((t5) => {
  let e5 = "";
  for (const s4 of t5.cssRules) e5 += s4.cssText;
  return r(e5);
})(t4) : t4;

// node_modules/@lit/reactive-element/reactive-element.js
var { is: i2, defineProperty: e2, getOwnPropertyDescriptor: h, getOwnPropertyNames: r2, getOwnPropertySymbols: o2, getPrototypeOf: n2 } = Object;
var a = globalThis;
var c2 = a.trustedTypes;
var l = c2 ? c2.emptyScript : "";
var p = a.reactiveElementPolyfillSupport;
var d = (t4, s4) => t4;
var u = { toAttribute(t4, s4) {
  switch (s4) {
    case Boolean:
      t4 = t4 ? l : null;
      break;
    case Object:
    case Array:
      t4 = null == t4 ? t4 : JSON.stringify(t4);
  }
  return t4;
}, fromAttribute(t4, s4) {
  let i5 = t4;
  switch (s4) {
    case Boolean:
      i5 = null !== t4;
      break;
    case Number:
      i5 = null === t4 ? null : Number(t4);
      break;
    case Object:
    case Array:
      try {
        i5 = JSON.parse(t4);
      } catch (t5) {
        i5 = null;
      }
  }
  return i5;
} };
var f = (t4, s4) => !i2(t4, s4);
var b = { attribute: true, type: String, converter: u, reflect: false, useDefault: false, hasChanged: f };
Symbol.metadata ??= /* @__PURE__ */ Symbol("metadata"), a.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
var y = class extends HTMLElement {
  static addInitializer(t4) {
    this._$Ei(), (this.l ??= []).push(t4);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t4, s4 = b) {
    if (s4.state && (s4.attribute = false), this._$Ei(), this.prototype.hasOwnProperty(t4) && ((s4 = Object.create(s4)).wrapped = true), this.elementProperties.set(t4, s4), !s4.noAccessor) {
      const i5 = /* @__PURE__ */ Symbol(), h3 = this.getPropertyDescriptor(t4, i5, s4);
      void 0 !== h3 && e2(this.prototype, t4, h3);
    }
  }
  static getPropertyDescriptor(t4, s4, i5) {
    const { get: e5, set: r6 } = h(this.prototype, t4) ?? { get() {
      return this[s4];
    }, set(t5) {
      this[s4] = t5;
    } };
    return { get: e5, set(s5) {
      const h3 = e5?.call(this);
      r6?.call(this, s5), this.requestUpdate(t4, h3, i5);
    }, configurable: true, enumerable: true };
  }
  static getPropertyOptions(t4) {
    return this.elementProperties.get(t4) ?? b;
  }
  static _$Ei() {
    if (this.hasOwnProperty(d("elementProperties"))) return;
    const t4 = n2(this);
    t4.finalize(), void 0 !== t4.l && (this.l = [...t4.l]), this.elementProperties = new Map(t4.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(d("finalized"))) return;
    if (this.finalized = true, this._$Ei(), this.hasOwnProperty(d("properties"))) {
      const t5 = this.properties, s4 = [...r2(t5), ...o2(t5)];
      for (const i5 of s4) this.createProperty(i5, t5[i5]);
    }
    const t4 = this[Symbol.metadata];
    if (null !== t4) {
      const s4 = litPropertyMetadata.get(t4);
      if (void 0 !== s4) for (const [t5, i5] of s4) this.elementProperties.set(t5, i5);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [t5, s4] of this.elementProperties) {
      const i5 = this._$Eu(t5, s4);
      void 0 !== i5 && this._$Eh.set(i5, t5);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(s4) {
    const i5 = [];
    if (Array.isArray(s4)) {
      const e5 = new Set(s4.flat(1 / 0).reverse());
      for (const s5 of e5) i5.unshift(c(s5));
    } else void 0 !== s4 && i5.push(c(s4));
    return i5;
  }
  static _$Eu(t4, s4) {
    const i5 = s4.attribute;
    return false === i5 ? void 0 : "string" == typeof i5 ? i5 : "string" == typeof t4 ? t4.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = false, this.hasUpdated = false, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    this._$ES = new Promise((t4) => this.enableUpdating = t4), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t4) => t4(this));
  }
  addController(t4) {
    (this._$EO ??= /* @__PURE__ */ new Set()).add(t4), void 0 !== this.renderRoot && this.isConnected && t4.hostConnected?.();
  }
  removeController(t4) {
    this._$EO?.delete(t4);
  }
  _$E_() {
    const t4 = /* @__PURE__ */ new Map(), s4 = this.constructor.elementProperties;
    for (const i5 of s4.keys()) this.hasOwnProperty(i5) && (t4.set(i5, this[i5]), delete this[i5]);
    t4.size > 0 && (this._$Ep = t4);
  }
  createRenderRoot() {
    const t4 = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return S(t4, this.constructor.elementStyles), t4;
  }
  connectedCallback() {
    this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(true), this._$EO?.forEach((t4) => t4.hostConnected?.());
  }
  enableUpdating(t4) {
  }
  disconnectedCallback() {
    this._$EO?.forEach((t4) => t4.hostDisconnected?.());
  }
  attributeChangedCallback(t4, s4, i5) {
    this._$AK(t4, i5);
  }
  _$ET(t4, s4) {
    const i5 = this.constructor.elementProperties.get(t4), e5 = this.constructor._$Eu(t4, i5);
    if (void 0 !== e5 && true === i5.reflect) {
      const h3 = (void 0 !== i5.converter?.toAttribute ? i5.converter : u).toAttribute(s4, i5.type);
      this._$Em = t4, null == h3 ? this.removeAttribute(e5) : this.setAttribute(e5, h3), this._$Em = null;
    }
  }
  _$AK(t4, s4) {
    const i5 = this.constructor, e5 = i5._$Eh.get(t4);
    if (void 0 !== e5 && this._$Em !== e5) {
      const t5 = i5.getPropertyOptions(e5), h3 = "function" == typeof t5.converter ? { fromAttribute: t5.converter } : void 0 !== t5.converter?.fromAttribute ? t5.converter : u;
      this._$Em = e5;
      const r6 = h3.fromAttribute(s4, t5.type);
      this[e5] = r6 ?? this._$Ej?.get(e5) ?? r6, this._$Em = null;
    }
  }
  requestUpdate(t4, s4, i5, e5 = false, h3) {
    if (void 0 !== t4) {
      const r6 = this.constructor;
      if (false === e5 && (h3 = this[t4]), i5 ??= r6.getPropertyOptions(t4), !((i5.hasChanged ?? f)(h3, s4) || i5.useDefault && i5.reflect && h3 === this._$Ej?.get(t4) && !this.hasAttribute(r6._$Eu(t4, i5)))) return;
      this.C(t4, s4, i5);
    }
    false === this.isUpdatePending && (this._$ES = this._$EP());
  }
  C(t4, s4, { useDefault: i5, reflect: e5, wrapped: h3 }, r6) {
    i5 && !(this._$Ej ??= /* @__PURE__ */ new Map()).has(t4) && (this._$Ej.set(t4, r6 ?? s4 ?? this[t4]), true !== h3 || void 0 !== r6) || (this._$AL.has(t4) || (this.hasUpdated || i5 || (s4 = void 0), this._$AL.set(t4, s4)), true === e5 && this._$Em !== t4 && (this._$Eq ??= /* @__PURE__ */ new Set()).add(t4));
  }
  async _$EP() {
    this.isUpdatePending = true;
    try {
      await this._$ES;
    } catch (t5) {
      Promise.reject(t5);
    }
    const t4 = this.scheduleUpdate();
    return null != t4 && await t4, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
        for (const [t6, s5] of this._$Ep) this[t6] = s5;
        this._$Ep = void 0;
      }
      const t5 = this.constructor.elementProperties;
      if (t5.size > 0) for (const [s5, i5] of t5) {
        const { wrapped: t6 } = i5, e5 = this[s5];
        true !== t6 || this._$AL.has(s5) || void 0 === e5 || this.C(s5, void 0, i5, e5);
      }
    }
    let t4 = false;
    const s4 = this._$AL;
    try {
      t4 = this.shouldUpdate(s4), t4 ? (this.willUpdate(s4), this._$EO?.forEach((t5) => t5.hostUpdate?.()), this.update(s4)) : this._$EM();
    } catch (s5) {
      throw t4 = false, this._$EM(), s5;
    }
    t4 && this._$AE(s4);
  }
  willUpdate(t4) {
  }
  _$AE(t4) {
    this._$EO?.forEach((t5) => t5.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = true, this.firstUpdated(t4)), this.updated(t4);
  }
  _$EM() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = false;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t4) {
    return true;
  }
  update(t4) {
    this._$Eq &&= this._$Eq.forEach((t5) => this._$ET(t5, this[t5])), this._$EM();
  }
  updated(t4) {
  }
  firstUpdated(t4) {
  }
};
y.elementStyles = [], y.shadowRootOptions = { mode: "open" }, y[d("elementProperties")] = /* @__PURE__ */ new Map(), y[d("finalized")] = /* @__PURE__ */ new Map(), p?.({ ReactiveElement: y }), (a.reactiveElementVersions ??= []).push("2.1.2");

// node_modules/lit-html/lit-html.js
var t2 = globalThis;
var i3 = (t4) => t4;
var s2 = t2.trustedTypes;
var e3 = s2 ? s2.createPolicy("lit-html", { createHTML: (t4) => t4 }) : void 0;
var h2 = "$lit$";
var o3 = `lit$${Math.random().toFixed(9).slice(2)}$`;
var n3 = "?" + o3;
var r3 = `<${n3}>`;
var l2 = document;
var c3 = () => l2.createComment("");
var a2 = (t4) => null === t4 || "object" != typeof t4 && "function" != typeof t4;
var u2 = Array.isArray;
var d2 = (t4) => u2(t4) || "function" == typeof t4?.[Symbol.iterator];
var f2 = "[ 	\n\f\r]";
var v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g;
var _ = /-->/g;
var m = />/g;
var p2 = RegExp(`>|${f2}(?:([^\\s"'>=/]+)(${f2}*=${f2}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g");
var g = /'/g;
var $ = /"/g;
var y2 = /^(?:script|style|textarea|title)$/i;
var x = (t4) => (i5, ...s4) => ({ _$litType$: t4, strings: i5, values: s4 });
var b2 = x(1);
var w = x(2);
var T = x(3);
var E = /* @__PURE__ */ Symbol.for("lit-noChange");
var A = /* @__PURE__ */ Symbol.for("lit-nothing");
var C = /* @__PURE__ */ new WeakMap();
var P = l2.createTreeWalker(l2, 129);
function V(t4, i5) {
  if (!u2(t4) || !t4.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return void 0 !== e3 ? e3.createHTML(i5) : i5;
}
var N = (t4, i5) => {
  const s4 = t4.length - 1, e5 = [];
  let n5, l3 = 2 === i5 ? "<svg>" : 3 === i5 ? "<math>" : "", c4 = v;
  for (let i6 = 0; i6 < s4; i6++) {
    const s5 = t4[i6];
    let a3, u3, d3 = -1, f3 = 0;
    for (; f3 < s5.length && (c4.lastIndex = f3, u3 = c4.exec(s5), null !== u3); ) f3 = c4.lastIndex, c4 === v ? "!--" === u3[1] ? c4 = _ : void 0 !== u3[1] ? c4 = m : void 0 !== u3[2] ? (y2.test(u3[2]) && (n5 = RegExp("</" + u3[2], "g")), c4 = p2) : void 0 !== u3[3] && (c4 = p2) : c4 === p2 ? ">" === u3[0] ? (c4 = n5 ?? v, d3 = -1) : void 0 === u3[1] ? d3 = -2 : (d3 = c4.lastIndex - u3[2].length, a3 = u3[1], c4 = void 0 === u3[3] ? p2 : '"' === u3[3] ? $ : g) : c4 === $ || c4 === g ? c4 = p2 : c4 === _ || c4 === m ? c4 = v : (c4 = p2, n5 = void 0);
    const x2 = c4 === p2 && t4[i6 + 1].startsWith("/>") ? " " : "";
    l3 += c4 === v ? s5 + r3 : d3 >= 0 ? (e5.push(a3), s5.slice(0, d3) + h2 + s5.slice(d3) + o3 + x2) : s5 + o3 + (-2 === d3 ? i6 : x2);
  }
  return [V(t4, l3 + (t4[s4] || "<?>") + (2 === i5 ? "</svg>" : 3 === i5 ? "</math>" : "")), e5];
};
var S2 = class _S {
  constructor({ strings: t4, _$litType$: i5 }, e5) {
    let r6;
    this.parts = [];
    let l3 = 0, a3 = 0;
    const u3 = t4.length - 1, d3 = this.parts, [f3, v2] = N(t4, i5);
    if (this.el = _S.createElement(f3, e5), P.currentNode = this.el.content, 2 === i5 || 3 === i5) {
      const t5 = this.el.content.firstChild;
      t5.replaceWith(...t5.childNodes);
    }
    for (; null !== (r6 = P.nextNode()) && d3.length < u3; ) {
      if (1 === r6.nodeType) {
        if (r6.hasAttributes()) for (const t5 of r6.getAttributeNames()) if (t5.endsWith(h2)) {
          const i6 = v2[a3++], s4 = r6.getAttribute(t5).split(o3), e6 = /([.?@])?(.*)/.exec(i6);
          d3.push({ type: 1, index: l3, name: e6[2], strings: s4, ctor: "." === e6[1] ? I : "?" === e6[1] ? L : "@" === e6[1] ? z : H }), r6.removeAttribute(t5);
        } else t5.startsWith(o3) && (d3.push({ type: 6, index: l3 }), r6.removeAttribute(t5));
        if (y2.test(r6.tagName)) {
          const t5 = r6.textContent.split(o3), i6 = t5.length - 1;
          if (i6 > 0) {
            r6.textContent = s2 ? s2.emptyScript : "";
            for (let s4 = 0; s4 < i6; s4++) r6.append(t5[s4], c3()), P.nextNode(), d3.push({ type: 2, index: ++l3 });
            r6.append(t5[i6], c3());
          }
        }
      } else if (8 === r6.nodeType) if (r6.data === n3) d3.push({ type: 2, index: l3 });
      else {
        let t5 = -1;
        for (; -1 !== (t5 = r6.data.indexOf(o3, t5 + 1)); ) d3.push({ type: 7, index: l3 }), t5 += o3.length - 1;
      }
      l3++;
    }
  }
  static createElement(t4, i5) {
    const s4 = l2.createElement("template");
    return s4.innerHTML = t4, s4;
  }
};
function M(t4, i5, s4 = t4, e5) {
  if (i5 === E) return i5;
  let h3 = void 0 !== e5 ? s4._$Co?.[e5] : s4._$Cl;
  const o6 = a2(i5) ? void 0 : i5._$litDirective$;
  return h3?.constructor !== o6 && (h3?._$AO?.(false), void 0 === o6 ? h3 = void 0 : (h3 = new o6(t4), h3._$AT(t4, s4, e5)), void 0 !== e5 ? (s4._$Co ??= [])[e5] = h3 : s4._$Cl = h3), void 0 !== h3 && (i5 = M(t4, h3._$AS(t4, i5.values), h3, e5)), i5;
}
var R = class {
  constructor(t4, i5) {
    this._$AV = [], this._$AN = void 0, this._$AD = t4, this._$AM = i5;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t4) {
    const { el: { content: i5 }, parts: s4 } = this._$AD, e5 = (t4?.creationScope ?? l2).importNode(i5, true);
    P.currentNode = e5;
    let h3 = P.nextNode(), o6 = 0, n5 = 0, r6 = s4[0];
    for (; void 0 !== r6; ) {
      if (o6 === r6.index) {
        let i6;
        2 === r6.type ? i6 = new k(h3, h3.nextSibling, this, t4) : 1 === r6.type ? i6 = new r6.ctor(h3, r6.name, r6.strings, this, t4) : 6 === r6.type && (i6 = new Z(h3, this, t4)), this._$AV.push(i6), r6 = s4[++n5];
      }
      o6 !== r6?.index && (h3 = P.nextNode(), o6++);
    }
    return P.currentNode = l2, e5;
  }
  p(t4) {
    let i5 = 0;
    for (const s4 of this._$AV) void 0 !== s4 && (void 0 !== s4.strings ? (s4._$AI(t4, s4, i5), i5 += s4.strings.length - 2) : s4._$AI(t4[i5])), i5++;
  }
};
var k = class _k {
  get _$AU() {
    return this._$AM?._$AU ?? this._$Cv;
  }
  constructor(t4, i5, s4, e5) {
    this.type = 2, this._$AH = A, this._$AN = void 0, this._$AA = t4, this._$AB = i5, this._$AM = s4, this.options = e5, this._$Cv = e5?.isConnected ?? true;
  }
  get parentNode() {
    let t4 = this._$AA.parentNode;
    const i5 = this._$AM;
    return void 0 !== i5 && 11 === t4?.nodeType && (t4 = i5.parentNode), t4;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t4, i5 = this) {
    t4 = M(this, t4, i5), a2(t4) ? t4 === A || null == t4 || "" === t4 ? (this._$AH !== A && this._$AR(), this._$AH = A) : t4 !== this._$AH && t4 !== E && this._(t4) : void 0 !== t4._$litType$ ? this.$(t4) : void 0 !== t4.nodeType ? this.T(t4) : d2(t4) ? this.k(t4) : this._(t4);
  }
  O(t4) {
    return this._$AA.parentNode.insertBefore(t4, this._$AB);
  }
  T(t4) {
    this._$AH !== t4 && (this._$AR(), this._$AH = this.O(t4));
  }
  _(t4) {
    this._$AH !== A && a2(this._$AH) ? this._$AA.nextSibling.data = t4 : this.T(l2.createTextNode(t4)), this._$AH = t4;
  }
  $(t4) {
    const { values: i5, _$litType$: s4 } = t4, e5 = "number" == typeof s4 ? this._$AC(t4) : (void 0 === s4.el && (s4.el = S2.createElement(V(s4.h, s4.h[0]), this.options)), s4);
    if (this._$AH?._$AD === e5) this._$AH.p(i5);
    else {
      const t5 = new R(e5, this), s5 = t5.u(this.options);
      t5.p(i5), this.T(s5), this._$AH = t5;
    }
  }
  _$AC(t4) {
    let i5 = C.get(t4.strings);
    return void 0 === i5 && C.set(t4.strings, i5 = new S2(t4)), i5;
  }
  k(t4) {
    u2(this._$AH) || (this._$AH = [], this._$AR());
    const i5 = this._$AH;
    let s4, e5 = 0;
    for (const h3 of t4) e5 === i5.length ? i5.push(s4 = new _k(this.O(c3()), this.O(c3()), this, this.options)) : s4 = i5[e5], s4._$AI(h3), e5++;
    e5 < i5.length && (this._$AR(s4 && s4._$AB.nextSibling, e5), i5.length = e5);
  }
  _$AR(t4 = this._$AA.nextSibling, s4) {
    for (this._$AP?.(false, true, s4); t4 !== this._$AB; ) {
      const s5 = i3(t4).nextSibling;
      i3(t4).remove(), t4 = s5;
    }
  }
  setConnected(t4) {
    void 0 === this._$AM && (this._$Cv = t4, this._$AP?.(t4));
  }
};
var H = class {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t4, i5, s4, e5, h3) {
    this.type = 1, this._$AH = A, this._$AN = void 0, this.element = t4, this.name = i5, this._$AM = e5, this.options = h3, s4.length > 2 || "" !== s4[0] || "" !== s4[1] ? (this._$AH = Array(s4.length - 1).fill(new String()), this.strings = s4) : this._$AH = A;
  }
  _$AI(t4, i5 = this, s4, e5) {
    const h3 = this.strings;
    let o6 = false;
    if (void 0 === h3) t4 = M(this, t4, i5, 0), o6 = !a2(t4) || t4 !== this._$AH && t4 !== E, o6 && (this._$AH = t4);
    else {
      const e6 = t4;
      let n5, r6;
      for (t4 = h3[0], n5 = 0; n5 < h3.length - 1; n5++) r6 = M(this, e6[s4 + n5], i5, n5), r6 === E && (r6 = this._$AH[n5]), o6 ||= !a2(r6) || r6 !== this._$AH[n5], r6 === A ? t4 = A : t4 !== A && (t4 += (r6 ?? "") + h3[n5 + 1]), this._$AH[n5] = r6;
    }
    o6 && !e5 && this.j(t4);
  }
  j(t4) {
    t4 === A ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t4 ?? "");
  }
};
var I = class extends H {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t4) {
    this.element[this.name] = t4 === A ? void 0 : t4;
  }
};
var L = class extends H {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t4) {
    this.element.toggleAttribute(this.name, !!t4 && t4 !== A);
  }
};
var z = class extends H {
  constructor(t4, i5, s4, e5, h3) {
    super(t4, i5, s4, e5, h3), this.type = 5;
  }
  _$AI(t4, i5 = this) {
    if ((t4 = M(this, t4, i5, 0) ?? A) === E) return;
    const s4 = this._$AH, e5 = t4 === A && s4 !== A || t4.capture !== s4.capture || t4.once !== s4.once || t4.passive !== s4.passive, h3 = t4 !== A && (s4 === A || e5);
    e5 && this.element.removeEventListener(this.name, this, s4), h3 && this.element.addEventListener(this.name, this, t4), this._$AH = t4;
  }
  handleEvent(t4) {
    "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t4) : this._$AH.handleEvent(t4);
  }
};
var Z = class {
  constructor(t4, i5, s4) {
    this.element = t4, this.type = 6, this._$AN = void 0, this._$AM = i5, this.options = s4;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t4) {
    M(this, t4);
  }
};
var B = t2.litHtmlPolyfillSupport;
B?.(S2, k), (t2.litHtmlVersions ??= []).push("3.3.3");
var D = (t4, i5, s4) => {
  const e5 = s4?.renderBefore ?? i5;
  let h3 = e5._$litPart$;
  if (void 0 === h3) {
    const t5 = s4?.renderBefore ?? null;
    e5._$litPart$ = h3 = new k(i5.insertBefore(c3(), t5), t5, void 0, s4 ?? {});
  }
  return h3._$AI(t4), h3;
};

// node_modules/lit-element/lit-element.js
var s3 = globalThis;
var i4 = class extends y {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    const t4 = super.createRenderRoot();
    return this.renderOptions.renderBefore ??= t4.firstChild, t4;
  }
  update(t4) {
    const r6 = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t4), this._$Do = D(r6, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    super.connectedCallback(), this._$Do?.setConnected(true);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._$Do?.setConnected(false);
  }
  render() {
    return E;
  }
};
i4._$litElement$ = true, i4["finalized"] = true, s3.litElementHydrateSupport?.({ LitElement: i4 });
var o4 = s3.litElementPolyfillSupport;
o4?.({ LitElement: i4 });
(s3.litElementVersions ??= []).push("4.2.2");

// node_modules/@lit/reactive-element/decorators/custom-element.js
var t3 = (t4) => (e5, o6) => {
  void 0 !== o6 ? o6.addInitializer(() => {
    customElements.define(t4, e5);
  }) : customElements.define(t4, e5);
};

// node_modules/@lit/reactive-element/decorators/property.js
var o5 = { attribute: true, type: String, converter: u, reflect: false, hasChanged: f };
var r4 = (t4 = o5, e5, r6) => {
  const { kind: n5, metadata: i5 } = r6;
  let s4 = globalThis.litPropertyMetadata.get(i5);
  if (void 0 === s4 && globalThis.litPropertyMetadata.set(i5, s4 = /* @__PURE__ */ new Map()), "setter" === n5 && ((t4 = Object.create(t4)).wrapped = true), s4.set(r6.name, t4), "accessor" === n5) {
    const { name: o6 } = r6;
    return { set(r7) {
      const n6 = e5.get.call(this);
      e5.set.call(this, r7), this.requestUpdate(o6, n6, t4, true, r7);
    }, init(e6) {
      return void 0 !== e6 && this.C(o6, void 0, t4, e6), e6;
    } };
  }
  if ("setter" === n5) {
    const { name: o6 } = r6;
    return function(r7) {
      const n6 = this[o6];
      e5.call(this, r7), this.requestUpdate(o6, n6, t4, true, r7);
    };
  }
  throw Error("Unsupported decorator location: " + n5);
};
function n4(t4) {
  return (e5, o6) => "object" == typeof o6 ? r4(t4, e5, o6) : ((t5, e6, o7) => {
    const r6 = e6.hasOwnProperty(o7);
    return e6.constructor.createProperty(o7, t5), r6 ? Object.getOwnPropertyDescriptor(e6, o7) : void 0;
  })(t4, e5, o6);
}

// node_modules/@lit/reactive-element/decorators/state.js
function r5(r6) {
  return n4({ ...r6, state: true, attribute: false });
}

// components/styles/shared.ts
var shared = i`
  button {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;
  }

  button:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }

  .button-wrapper {
    all: unset;
    box-sizing: border-box;
    display: flex;
    cursor: pointer;
  }

  * {
    box-sizing: border-box;
    min-width: 0;
  }

  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }
`;

// components/base-component.ts
var BaseComponent = class extends i4 {
  static {
    this.styles = [shared];
  }
};

// components/ds-review-card/ds-review-card.ts
var SOUND_CLAIM = "ds-review-card-play";
var MIN_VISIBLE_RATIO = 0.5;
var ACTIVE_RATIO = 0.9;
var SIDEBAR_QUERY = "(min-width: 1024px)";
var HOVER_QUERY = "(hover: hover)";
var soundPreferred = false;
var DsReviewCard = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.quote = "";
    this.author = "";
    this.image = "";
    this.video = "";
    this.videoType = "external";
    this.poster = "";
    this.aspect = "";
    this._playing = false;
    this._muted = true;
    this._measured = "";
    /**
     * Whether the viewer is currently on this card — hovering it with a mouse, or
     * having scrolled it into place on a touch device. Only used to decide where a
     * finished playthrough lands: still engaged goes back to the silent preview,
     * so the card doesn't dead-end on a poster under the pointer.
     */
    this._engaged = false;
    /**
     * Invalidates in-flight `play()` promises.
     *
     * `pause()` rejects a pending `play()` with `AbortError`, and at the catch site
     * that is indistinguishable from the browser refusing to play. So every attempt
     * takes a token, and a rejection is acted on only if it still belongs to the
     * current one.
     *
     * Without this a deliberate stop — pointer-leave, a sibling claiming sound,
     * scrolling away — lands in the failure path and *restarts* the video, which on
     * the hover-driven path has nothing left to stop it. The window is not small
     * either: `preload="metadata"` means the first play on a card has to buffer, so
     * the promise stays pending for a good fraction of a second.
     */
    this._playToken = 0;
    this._visibility = null;
    this._sidebar = null;
    this._hover = null;
    /**
     * Watches how much of the card is on screen — only when playback isn't already
     * bounded by the pointer.
     *
     * Where hover drives it, playback lives and dies with the pointer: you can only
     * be over one card at a time and leaving stops it, so nothing can be left
     * running off-screen and there is nothing for an observer to catch. Every other
     * case outlives the pointer — taps, embeds, reduced motion — and needs this.
     *
     * Rooted on the viewport, which covers both scroll axes at once: an observer
     * clips the target against every ancestor scroll container, so a card scrolled
     * sideways out of the review row reports as out of view without us observing
     * the row itself, and vertical page scrolling falls out for free.
     *
     * What it does *not* get for free is occlusion. At >=1024px the sidebar is
     * `position: fixed` over the left 477px of the viewport (--sidebar-offset in
     * assets/base.css) and the row is deliberately scrolled underneath it, but no
     * browser API reports "hidden behind another element" — intersection is purely
     * geometric, so a card completely covered by the sidebar still reports a ratio
     * of 1. Shrinking the root by that width models the one occluder we know
     * about, which is why the inset is read from the variable rather than assumed.
     * That combination is rarer than it sounds but real: a large tablet is over
     * 1024px wide with no hover, so it gets the left column and the observer both.
     *
     * Below 1024px the offset is 0 and the sidebar is a bottom bar instead; its
     * height is dynamic and collapses on scroll, so it is not modelled here.
     */
    this._syncVisibility = () => {
      this._visibility?.disconnect();
      this._visibility = null;
      this.requestUpdate();
      if (this._hoverDriven) return;
      const offset = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--sidebar-offset"
        )
      ) || 0;
      this._visibility = new IntersectionObserver(this._onVisibility, {
        rootMargin: `0px 0px 0px ${offset > 0 ? `-${offset}px` : "0px"}`,
        threshold: [MIN_VISIBLE_RATIO, ACTIVE_RATIO]
      });
      this._visibility.observe(this);
    };
    this._onVisibility = (entries) => {
      for (const entry of entries) {
        const ratio = entry.intersectionRatio;
        const video = this._video;
        const running = video ? !video.paused : this._playing;
        if (ratio >= ACTIVE_RATIO) this._engaged = true;
        else if (ratio < MIN_VISIBLE_RATIO) this._engaged = false;
        if (running && ratio < MIN_VISIBLE_RATIO) {
          this._reset();
          continue;
        }
        if (!running && this._isUpload && this.video && this._motionAllowed && ratio >= ACTIVE_RATIO) {
          this._startPreview();
        }
      }
    };
    /** Arrow function so the identity stays stable for removeEventListener. */
    this._onSiblingClaimedSound = (e5) => {
      if (e5.target === this) return;
      if (this._playing && !this._muted) this._reset();
    };
  }
  get _video() {
    return this.shadowRoot?.querySelector("video") ?? null;
  }
  get _isUpload() {
    return this.videoType === "upload";
  }
  /** Hover playback is motion the user didn't ask for, so reduced-motion opts out. */
  get _motionAllowed() {
    return !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
  /** Split between the two interaction models. */
  get _hasHover() {
    return window.matchMedia(HOVER_QUERY).matches;
  }
  /**
   * Whether this card's playback is scoped to the pointer: hover starts it,
   * leaving ends it, and nothing else is needed to bound it. Three things follow
   * from it together, which is why it's one property rather than three checks —
   * click targets go inert, pointer-leave stops playback, and no visibility
   * observer is needed.
   *
   * All three conditions matter, and each excluded case is one where playback is
   * *not* pointer-bound and so still needs the click and the observer:
   *
   * - No hover: nothing starts on its own, and taps are the way in.
   * - Embeds: can't be hover-previewed at all — there's no handle on iframe
   *   playback — so they're click-started and outlive the pointer.
   * - `prefers-reduced-motion`: hover deliberately doesn't preview, so the click
   *   has to stay live or the people who opted out of motion lose video
   *   entirely.
   */
  get _hoverDriven() {
    return this._hasHover && this._isUpload && this._motionAllowed;
  }
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener(SOUND_CLAIM, this._onSiblingClaimedSound);
    this._sidebar = window.matchMedia(SIDEBAR_QUERY);
    this._hover = window.matchMedia(HOVER_QUERY);
    this._sidebar.addEventListener("change", this._syncVisibility);
    this._hover.addEventListener("change", this._syncVisibility);
    this._syncVisibility();
  }
  disconnectedCallback() {
    window.removeEventListener(SOUND_CLAIM, this._onSiblingClaimedSound);
    this._sidebar?.removeEventListener("change", this._syncVisibility);
    this._hover?.removeEventListener("change", this._syncVisibility);
    this._sidebar = null;
    this._hover = null;
    this._visibility?.disconnect();
    this._visibility = null;
    super.disconnectedCallback();
  }
  _claimSound() {
    this.dispatchEvent(
      new CustomEvent(SOUND_CLAIM, { bubbles: true, composed: true })
    );
  }
  /**
   * Starts playback and routes a genuine refusal to `onRefused`, ignoring the
   * rejection that a later reset or a newer attempt causes. See `_playToken`.
   */
  _attemptPlay(video, onRefused) {
    const token = ++this._playToken;
    video.play().catch(() => {
      if (token === this._playToken) onRefused();
    });
  }
  /**
   * The one way a preview starts, from either trigger. Honours the running sound
   * preference, so once the viewer has turned audio on the next card they land on
   * carries it rather than dropping back to silence.
   */
  _startPreview() {
    if (soundPreferred) {
      this._playWithSound();
    } else {
      this._previewSilently();
    }
  }
  /** Silent looping preview — the hover state, and the active-card state. */
  _previewSilently() {
    const video = this._video;
    if (!video) return;
    video.currentTime = 0;
    video.muted = true;
    video.loop = true;
    this._muted = true;
    this._playing = true;
    this._attemptPlay(video, () => {
      this._playing = false;
    });
  }
  /**
   * Sound plays through once rather than looping — a looping voice is grating,
   * and it gives `ended` a chance to fire so the card can return to its poster.
   *
   * Called straight from the click handler with no `await` in front of `play()`:
   * the `<video>` is always in the DOM (only the chrome over it is conditional),
   * so there is no render to wait for and the user gesture is still current.
   * That gesture is the only thing that makes unmuted playback legal.
   */
  _playWithSound() {
    const video = this._video;
    if (!video) return;
    video.muted = false;
    video.loop = false;
    this._muted = false;
    this._playing = true;
    soundPreferred = true;
    this._claimSound();
    this._attemptPlay(video, () => this._onSoundRefused());
  }
  /**
   * Unmuted playback was refused — iOS Low Power Mode, or a browser that gates
   * audio per element rather than per document.
   *
   * Falls back to a silent preview rather than to nothing, and puts `_muted` back
   * so the toggle shows the mute icon: the control must never claim sound that
   * isn't playing.
   *
   * Clearing the shared preference matters as much as the fallback. A browser
   * that won't allow sound now won't for the next card either, so leaving it set
   * would mean every card attempting audio, failing, and visibly correcting its
   * own icon. One refusal is enough to stop asking.
   */
  _onSoundRefused() {
    soundPreferred = false;
    const video = this._video;
    if (!video) {
      this._reset();
      return;
    }
    video.muted = true;
    video.loop = true;
    this._muted = true;
    this._attemptPlay(video, () => this._reset());
  }
  _reset() {
    this._playToken++;
    const video = this._video;
    if (video) {
      video.pause();
      video.currentTime = 0;
      video.muted = true;
      video.loop = true;
    }
    this._playing = false;
    this._muted = true;
  }
  /**
   * Only reachable after a sound playthrough — silent previews loop instead.
   *
   * Falls back to the silent preview while the viewer is still on the card,
   * rather than resetting. Otherwise finishing a review would leave a poster
   * sitting under the pointer with no way back: the play button is inert where
   * there's hover, so nothing would restart it short of leaving and returning.
   */
  /**
   * The element gets paused without us asking, and more often than you'd expect:
   * iOS permits only one audio stream, so starting sound on one card silently
   * pauses whichever other one was playing, and the OS pauses media on calls and
   * other interruptions.
   *
   * Without this, `_playing` drifts out of step with the element — it stays true
   * while the video sits paused — which both leaves the wrong chrome showing and
   * makes the card look dead when you scroll back to it, since the start guard
   * sees a card that is supposedly already playing.
   */
  _onPause() {
    if (this._video?.paused) this._playing = false;
  }
  _onEnded() {
    if (this._engaged && this._motionAllowed) {
      this._previewSilently();
    } else {
      this._reset();
    }
  }
  _onPointerEnter(e5) {
    if (e5.pointerType !== "mouse") return;
    this._engaged = true;
    if (this._playing || !this._motionAllowed) return;
    this._startPreview();
  }
  /**
   * Leaving stops hover-driven playback, sound included. That's what makes it
   * self-limiting — one card under the pointer, nothing running once you move off
   * — and in turn why it needs no observer.
   *
   * Playback that wasn't started by hover is left alone: an embed or a
   * reduced-motion click was a deliberate act, and tearing it down because the
   * pointer drifted would be wrong. Those cases have the observer instead.
   */
  _onPointerLeave(e5) {
    if (e5.pointerType !== "mouse") return;
    this._engaged = false;
    if (this._playing && this._hoverDriven) this._reset();
  }
  /**
   * The one click entry point, shared by the frame and the play button across
   * both media types. It branches internally rather than being split into two
   * handlers: the play button is common to both paths, so a handler that
   * silently no-ops for the wrong `videoType` just leaves the button dead.
   *
   * Click/tap is what makes sound legal, so it always ends in sound — including
   * from a silent hover preview, where stopping playback would misread the
   * gesture. A second click on an audible upload stops it.
   */
  _onActivate(e5) {
    e5.stopPropagation();
    if (!this._isUpload) {
      this._startExternal();
    } else if (this._playing && !this._muted) {
      this._reset();
    } else {
      this._playWithSound();
    }
  }
  /**
   * Muting mid-playthrough hands the card back to the silent looping preview, and
   * clears the shared preference — turning sound off is a decision about every
   * card that follows, not just this one.
   */
  _onToggleSound(e5) {
    e5.stopPropagation();
    if (this._muted) {
      this._playWithSound();
      return;
    }
    soundPreferred = false;
    const video = this._video;
    if (video) {
      video.muted = true;
      video.loop = true;
    }
    this._muted = true;
  }
  /**
   * Hosted players come up audible — `autoplay=1` carries no mute parameter and
   * the click that creates the iframe is a real gesture — so this claims sound
   * the same way an upload does. There is no `play()` to call: rendering the
   * iframe is what starts it.
   */
  _startExternal() {
    this._muted = false;
    this._playing = true;
    this._claimSound();
  }
  /** Real aspect ratio, so a 9:16 phone video renders tall instead of letterboxed in a 16:9 frame. */
  _onMetadata(e5) {
    const video = e5.target;
    if (video.videoWidth && video.videoHeight) {
      this._measured = `${video.videoWidth} / ${video.videoHeight}`;
    }
  }
  _autoplayUrl(url) {
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}autoplay=1`;
  }
  /**
   * Seeking a hair past the start makes browsers paint the first frame as the
   * preview. Only needed when Shopify hasn't given us a poster image.
   */
  _videoSrc() {
    const poster = this.poster || this.image;
    if (poster || this.video.includes("#")) return this.video;
    return `${this.video}#t=0.1`;
  }
  _frameStyle(fallback) {
    return `aspect-ratio: ${this._measured || this.aspect || fallback}`;
  }
  /**
   * Kept as the idle affordance even where it does nothing — it's what signals
   * "this is a video" before anything moves. Where hover drives playback it is
   * `disabled`, so it stops claiming to assistive tech that it can be operated,
   * and drops out of the tab order rather than becoming a focusable no-op.
   */
  _renderPlayButton() {
    const inert = this._hoverDriven;
    return b2`<button
      type="button"
      class="play-btn ${this._playing ? "hidden" : ""}"
      aria-label="Play video"
      ?disabled="${inert}"
      @click="${inert ? A : this._onActivate}"
    >
      <ds-icon name="play" size="24"></ds-icon>
    </button>`;
  }
  _renderSoundToggle() {
    const muted = this._muted;
    return b2`<button
      type="button"
      class="sound-btn ${this._playing ? "" : "hidden"}"
      aria-label="Video sound"
      aria-pressed="${muted ? "false" : "true"}"
      @click="${this._onToggleSound}"
    >
      <ds-icon name="${muted ? "volume-x" : "volume-2"}" size="18"></ds-icon>
    </button>`;
  }
  _renderUpload() {
    return b2`<div
      class="media media-frame media-video ${this._hoverDriven ? "inert" : ""}"
      style="${this._frameStyle("1")}"
      @pointerenter="${this._onPointerEnter}"
      @pointerleave="${this._onPointerLeave}"
      @click="${this._hoverDriven ? A : this._onActivate}"
    >
      <video
        src="${this._videoSrc()}"
        poster="${this.poster || this.image || A}"
        preload="metadata"
        playsinline
        loop
        muted
        .muted="${this._muted}"
        .loop="${this._muted}"
        @loadedmetadata="${this._onMetadata}"
        @ended="${this._onEnded}"
        @pause="${this._onPause}"
      ></video>
      ${/* Both always rendered — the handover between them is animated, which
      needs them both present. CSS decides which one is showing. A side
      benefit: the volume icon is fetched up front, so the toggle doesn't
      arrive empty on the first hover. */
    ""}
      ${this._renderPlayButton()} ${this._renderSoundToggle()}
    </div>`;
  }
  _renderExternal() {
    return b2`<div
      class="media media-frame ${this._playing ? "" : "media-video"}"
      style="${this._frameStyle("16 / 9")}"
      @click="${this._playing ? A : this._onActivate}"
    >
      ${this._playing ? b2`<iframe
            src="${this._autoplayUrl(this.video)}"
            title="Video review"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>` : b2`${this.poster || this.image ? b2`<img src="${this.poster || this.image}" loading="lazy" alt="" />` : A}
          ${this._renderPlayButton()}`}
    </div>`;
  }
  render() {
    const hasVideo = !!this.video;
    const hasImage = !!this.image;
    const hasMedia = hasVideo || hasImage;
    const hasQuote = !!this.quote;
    return b2`
      ${hasVideo ? this._isUpload ? this._renderUpload() : this._renderExternal() : hasImage ? b2`<div class="media">
              <img src="${this.image}" loading="lazy" alt="" />
            </div>` : A}
      ${hasQuote ? b2`<div class="${hasMedia ? "body" : "body-quote"}">
            <ds-text variant="${hasMedia ? "body" : "subheading"}"
              >"${this.quote}"</ds-text
            >
            ${this.author ? b2`<ds-text variant="caption" color="black-700" class="author"
                  >— ${this.author}</ds-text
                >` : A}
          </div>` : A}
    `;
  }
};
DsReviewCard.styles = [...BaseComponent.styles, r(ds_review_card_default)];
__decorateClass([
  n4()
], DsReviewCard.prototype, "quote", 2);
__decorateClass([
  n4()
], DsReviewCard.prototype, "author", 2);
__decorateClass([
  n4()
], DsReviewCard.prototype, "image", 2);
__decorateClass([
  n4()
], DsReviewCard.prototype, "video", 2);
__decorateClass([
  n4({ attribute: "video-type" })
], DsReviewCard.prototype, "videoType", 2);
__decorateClass([
  n4()
], DsReviewCard.prototype, "poster", 2);
__decorateClass([
  n4()
], DsReviewCard.prototype, "aspect", 2);
__decorateClass([
  r5()
], DsReviewCard.prototype, "_playing", 2);
__decorateClass([
  r5()
], DsReviewCard.prototype, "_muted", 2);
__decorateClass([
  r5()
], DsReviewCard.prototype, "_measured", 2);
DsReviewCard = __decorateClass([
  t3("ds-review-card")
], DsReviewCard);
export {
  DsReviewCard
};
/*! Bundled license information:

@lit/reactive-element/css-tag.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/reactive-element.js:
lit-html/lit-html.js:
lit-element/lit-element.js:
@lit/reactive-element/decorators/custom-element.js:
@lit/reactive-element/decorators/property.js:
@lit/reactive-element/decorators/state.js:
@lit/reactive-element/decorators/event-options.js:
@lit/reactive-element/decorators/base.js:
@lit/reactive-element/decorators/query.js:
@lit/reactive-element/decorators/query-all.js:
@lit/reactive-element/decorators/query-async.js:
@lit/reactive-element/decorators/query-assigned-nodes.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/is-server.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-elements.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
